import { WorkloadClient } from '@internal/workload-api-helper';

// TODO: Dead code?
export const fetchWorkloadData = async (
  accountId: string,
  workloadClient: WorkloadClient,
) => {
  return await workloadClient.apiFetch(`workloads/${accountId}`);
};

export const parseWorkloadObjectValues = (
  catalogLocationStringList: string[] | undefined,
): { [key: string]: string | undefined } => {
  const resourceFileName: string | undefined = catalogLocationStringList?.pop();
  const resourceName = resourceFileName?.split('.')[0];
  const workload = catalogLocationStringList?.pop();

  return {
    resourceName,
    workload,
  };
};
